class ModalAlert {

	constructor() {

		const modal = document.querySelector('#modal_alert');

		if (modal) {

			const modalCloseBtn = modal.querySelector('.modal-close');
			const modalRedirectBtn = modal.querySelector('.modal-redirect');
			const homeUrl = modal.dataset.homeUrl;

			let cookie_id = 'legal-popup-' + modal.dataset.cookieId;
			let cookie_value = localStorage.getItem(cookie_id);

			const myModal = new bootstrap.Modal('#modal_alert', {
				keyboard: false,
				backdrop: 'static'
			});

			if (cookie_value != 'fired') {
				myModal.show();

				modalCloseBtn.addEventListener('click', (e) => {
					e.preventDefault();
					myModal.hide();
					document.body.classList.add("modal-ok");
					localStorage.setItem(cookie_id, 'fired');
				});

				modalRedirectBtn.addEventListener('click', (e) => {
					e.preventDefault();
					document.location.href = homeUrl;
				});

			} else {
				document.body.classList.add("modal-ok");
			}
		}

	}

}